import React, { Component } from 'react';
import { Transfer } from 'antd';
import PropTypes from 'prop-types';

class Transfer_C extends Component {
    constructor(props) {
        super(props);
        this.transferChange = this.transferChange.bind(this)
    }

    transferChange = (nextTargetKeys, direction, moveKeys) => {
        const { feild } = this.props;
        console.log(nextTargetKeys)
        this.props.setValue(feild, nextTargetKeys);
    }

    render() {
        const { dataSource, targetKeys, name, disabled, showSearch } = this.props;

        return (
            <Transfer
                showSearch={showSearch}
                disabled={disabled}
                dataSource={dataSource}
                targetKeys={targetKeys}
                titles={['待选人员', '已选人员']}
                render={item => item[name]}
                rowKey={record => record.id}
                onChange={this.transferChange}
            />
        )
    }
}


Transfer_C.propTypes = {
    setValue: PropTypes.func.isRequired,
    dataSource: PropTypes.array.isRequired,
    targetKeys: PropTypes.array.isRequired,
    name: PropTypes.string.isRequired,
    feild: PropTypes.string.isRequired,
}

export default Transfer_C;

